import Reflux from 'reflux';

let UpgradeAlertModalActions = Reflux.createActions({
  showAlert: {},
  clear: {},
});

export default UpgradeAlertModalActions;
